/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
type FolderWrapper_viewer$ref = any;
type HeartWrapper_viewer$ref = any;
export type FavoritesProviderQueryVariables = {
    readonly loadPortfolioData?: boolean | null;
    readonly selectedItemIds?: ReadonlyArray<string | null> | null;
    readonly userIds?: ReadonlyArray<string | null> | null;
    readonly userId?: string | null;
    readonly fetchUser?: boolean | null;
    readonly shouldFillInFolder?: boolean | null;
};
export type FavoritesProviderQueryResponse = {
    readonly viewer: {
        readonly user?: {
            readonly isVerifiedTrade: boolean | null;
        } | null;
        readonly " $fragmentRefs": FolderWrapper_viewer$ref & HeartWrapper_viewer$ref;
    } | null;
};
export type FavoritesProviderQuery = {
    readonly response: FavoritesProviderQueryResponse;
    readonly variables: FavoritesProviderQueryVariables;
};



const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "loadPortfolioData",
            "type": "Boolean",
            "defaultValue": false
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "selectedItemIds",
            "type": "[String]",
            "defaultValue": ([] /*: any*/)
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "userIds",
            "type": "[String]",
            "defaultValue": ([] /*: any*/)
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "userId",
            "type": "String",
            "defaultValue": ""
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "fetchUser",
            "type": "Boolean",
            "defaultValue": false
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "shouldFillInFolder",
            "type": "Boolean",
            "defaultValue": false
        } as any)
    ], v1 = [
        ({
            "kind": "Variable",
            "name": "userId",
            "variableName": "userId"
        } as any)
    ], v2 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "isVerifiedTrade",
        "args": null,
        "storageKey": null
    } as any), v3 = ({
        "kind": "Variable",
        "name": "selectedItemIds",
        "variableName": "selectedItemIds"
    } as any), v4 = ({
        "kind": "Variable",
        "name": "userIds",
        "variableName": "userIds"
    } as any), v5 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "__typename",
        "args": null,
        "storageKey": null
    } as any), v6 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any), v7 = ({
        "kind": "Variable",
        "name": "itemIds",
        "variableName": "selectedItemIds"
    } as any), v8 = [
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "serviceId",
            "args": null,
            "storageKey": null
        } as any),
        (v6 /*: any*/)
    ], v9 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "item",
        "storageKey": null,
        "args": null,
        "concreteType": "Item",
        "plural": false,
        "selections": (v8 /*: any*/)
    } as any), v10 = ({
        "kind": "Literal",
        "name": "portfolioTypes",
        "value": [
            "HEART"
        ]
    } as any);
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "FavoritesProviderQuery",
            "type": "RootQueryType",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "Condition",
                            "passingValue": true,
                            "condition": "fetchUser",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "user",
                                    "storageKey": null,
                                    "args": (v1 /*: any*/),
                                    "concreteType": "User",
                                    "plural": false,
                                    "selections": [
                                        (v2 /*: any*/)
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "FolderWrapper_viewer",
                            "args": [
                                (v3 /*: any*/),
                                {
                                    "kind": "Variable",
                                    "name": "shouldFillInFolder",
                                    "variableName": "shouldFillInFolder"
                                },
                                (v4 /*: any*/)
                            ]
                        },
                        {
                            "kind": "FragmentSpread",
                            "name": "HeartWrapper_viewer",
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "loadPortfolioData",
                                    "variableName": "loadPortfolioData"
                                },
                                (v3 /*: any*/),
                                (v4 /*: any*/)
                            ]
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "FavoritesProviderQuery",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        (v5 /*: any*/),
                        (v6 /*: any*/),
                        {
                            "kind": "Condition",
                            "passingValue": true,
                            "condition": "fetchUser",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "user",
                                    "storageKey": null,
                                    "args": (v1 /*: any*/),
                                    "concreteType": "User",
                                    "plural": false,
                                    "selections": [
                                        (v2 /*: any*/),
                                        (v6 /*: any*/)
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "Condition",
                            "passingValue": true,
                            "condition": "shouldFillInFolder",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": "folderItemMatches",
                                    "name": "portfolioItemMatches",
                                    "storageKey": null,
                                    "args": [
                                        (v7 /*: any*/),
                                        {
                                            "kind": "Literal",
                                            "name": "portfolioTypes",
                                            "value": [
                                                "FOLDER"
                                            ]
                                        },
                                        (v4 /*: any*/)
                                    ],
                                    "concreteType": "PortfolioItemV2",
                                    "plural": true,
                                    "selections": [
                                        (v5 /*: any*/),
                                        (v9 /*: any*/),
                                        (v6 /*: any*/)
                                    ]
                                }
                            ]
                        },
                        {
                            "kind": "Condition",
                            "passingValue": true,
                            "condition": "loadPortfolioData",
                            "selections": [
                                {
                                    "kind": "LinkedField",
                                    "alias": "heartItemMatches",
                                    "name": "portfolioItemMatches",
                                    "storageKey": null,
                                    "args": [
                                        (v7 /*: any*/),
                                        (v10 /*: any*/),
                                        (v4 /*: any*/)
                                    ],
                                    "concreteType": "PortfolioItemV2",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "portfolioId",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "portfolioItemId",
                                            "args": null,
                                            "storageKey": null
                                        },
                                        (v9 /*: any*/),
                                        (v6 /*: any*/)
                                    ]
                                },
                                {
                                    "kind": "LinkedField",
                                    "alias": "userPortfolios",
                                    "name": "portfolios",
                                    "storageKey": null,
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 1
                                        },
                                        (v10 /*: any*/),
                                        (v4 /*: any*/)
                                    ],
                                    "concreteType": "PortfoliosConnection",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "edges",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "PortfoliosEdge",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "node",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "PortfolioV2",
                                                    "plural": false,
                                                    "selections": (v8 /*: any*/)
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "FavoritesProviderQuery",
            "id": "app-buyer-finding/231.0.0-2019-09-05T14:31:07.563Z/FavoritesProviderQuery",
            "text": null,
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '37a9d9c51797525482f41bb7a9710ab4';
export default node;
